export const supportEmail = "support@gtdiag.com";

export const BASE_URL = "https://study-configuration.stg.hipal-app.com";

export enum LanguageCode {
  en = "en",
  ms = "ms",
}

export const defaultLanguage = LanguageCode.en;

export const languageList = [
  { value: LanguageCode.en, label: "English" },
  { value: LanguageCode.ms, label: "Malay" },
];

// export enum LanguageCode {
//   en = "en-US",
//   fr = "fr-FR",
//   de = "de-DE",
//   ms = "ms-MY",
//   ua = "uk-UA",
// }
// export const languageList = [
//   { value: LanguageCode.en, label: "English" },
//   { value: LanguageCode.fr, label: "French" },
//   { value: LanguageCode.de, label: "German" },
//   { value: LanguageCode.ms, label: "Malay" },
//   { value: LanguageCode.ua, label: "Ukrainian" },
// ];
